import React, { Component } from 'react'
import { Row, Col } from 'antd'
import _ from 'lodash'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'

class Index extends Component {

	componentDidMount() {
		this.props.subscribeToImportProgress()
	}

	render() {
		const { isImporting, importProgress } = this.props

		if (_.has(importProgress, 'file_path')) {
			window.open(`${process.env.REACT_APP_BACKEND_API}${importProgress.file_path}`, '_blank')
		}
		return (
			<React.Fragment>
				{
					isImporting &&
					<div className="alert alert-icon alert-warning alert-dismissible fade show" role="alert">
						<i className="mdi mdi-alert mr-2"></i>
						{importProgress.message}
					</div>
				}
			</React.Fragment>
		)
	}
}

const composed = compose(
	inject('AuthStore'),
	observer
)

export default composed(Index)